var COEFFICIENTS, OUTCOME_SCALE_TYPES, QS, THRESHOLDS;

QS = require('models/outcome/quality_scores');

OUTCOME_SCALE_TYPES = ['ordinal', 'ratioOrInterval'];

THRESHOLDS = [0.073, 0.18, 0.338];

COEFFICIENTS = [0.061, 0.146, 0.271];

module.exports = {
  OUTCOME_SCALE_TYPES: OUTCOME_SCALE_TYPES,
  THRESHOLDS: THRESHOLDS,
  COEFFICIENTS: COEFFICIENTS,
  prepareDiagnosticOutcomes: function() {
    return ['TP', 'FN', 'TN', 'FP', 'Inconclusive', 'Complications'].map(function(name, idx) {
      return {
        name: name,
        largeEffect: QS.No,
        plausibleConfounding: QS.No,
        doseResponseGradient: QS.No,
        orderNumber: idx + 1
      };
    });
  }
};
